export default __webpack_public_path__ + "970550b779d5c724d06e1dcd66f467ae.png";